import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'underscore';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import { InlineErrors } from './sub-components/inline-errors';
import {
  vFParamsPropShape,
  disabledFieldOptionsShape,
  formDataShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import { ModalErrors } from '../modal-errors';
import { ModalSummary } from './summary-components/modal-summary/modal-summary';
import 'AppSrc/core/style/components/form/form-base-components/v-f-modal.css';

const CLOSED = 'Closed';

class VFEditTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalDisplayData: null,
      modalData: null,
      formData: null,
    };
    this.updateItem = this.updateItem.bind(this);
    this.editItem = this.editItem.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const {
      field,
    } = this.props;

    const {
      value,
    } = field;

    const formData = {
      ...value,
    };
    this.setState({
      formData,
      modalData: formData,
    });
  }

  editItem(sectionId) {
    this.setState({
      modalDisplayData: {
        sectionId,
        type: 'edit',
      },
    });
  }

  updateItem(data) {

    const {
      field,
    } = this.props;

    const {
      modalDisplayData,
    } = this.state;

    const { sectionId } = modalDisplayData;

    const {
      name,
      value,
    } = field;

    const currentSectionData = value[sectionId];

    // Merge the data from formik into the existing section data
    // This allows any non-field values
    // to be maintained
    const newSectionData = {
      ...currentSectionData,
      ...{
        ...data,
        ...{
          dataByFieldId: {
            ...data.dataByFieldId,
            status: {
              ...data.dataByFieldId.status,
              value: CLOSED,
            },
          },
        },
      },
    };

    // Merge the data form formil into the raw values
    // for ModalSummary display actual_start_time/actual_end_time
    // status changed to Closed.
    const dataToSave = {
      ...value,
      ...{
        dataByFormSectionId: {
          ...value.dataByFormSectionId,
          [sectionId]: newSectionData,
        },
      },
    };

    this.props.form.setFieldValue(name, dataToSave);
    this.props.form.setFieldTouched(name, true);

    this.setState({
      modalDisplayData: null,
      modalData: dataToSave,
      formData: dataToSave,
    });
  }


  closeModal() {
    this.setState({
      modalDisplayData: null,
    });
  }

  render() {

    const {
      modalDisplayData,
      formData,
      modalData,
    } = this.state;

    const {
      vFParams,
      field,
      form,
      disabledFieldOptions,
      outerFormData,
      readOnly,
    } = this.props;

    const {
      name,
      // value,
    } = field;

    const {
      disabled,
    } = disabledFieldOptions;

    const formErrors = form.errors;
    const touched = form.touched[name];


    const errors = formErrors[name];

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;
    const modalErrors = errors && errors.modalErrors ? errors.modalErrors : null;

    const {
      ModalSection,
      modalSummaryType,
      modalErrorsTitle,
    } = vFParams;

    const modalOptions = {
      saveChanges: true,
      saveChangesText: 'Confirm and close',
      cancel: this.closeModal,
    };


    const className = `v-f-field-type v-f-modal${disabled ? ' v-f-modal-disabled' : ''} v-f-modal-${name}`;

    const hasValue = !isEmpty(modalData);

    return (
      <div
        className={className}
      >
        { // Errors that need resolving through the modal. Such as mandatory formfields that need completed in the nested data
          modalErrors && (
            <ModalErrors
              modalErrorsTitle={modalErrorsTitle}
              errors={modalErrors}
            />
          )
        }

        {
          modalDisplayData && (
            <ModalPortal>
              <div
                className={`v-f-modal-section v-f-modal-section-${name}`}
              >
                <div className="v-f-modal-shadow" />
                <div className="v-f-modal-inner">
                  <ModalSection
                    handleSuccessfulSubmit={this.updateItem}
                    modalDisplayData={modalDisplayData}
                    formData={formData}
                    outerFormData={outerFormData}
                    modalOptions={modalOptions}
                  />
                </div>
              </div>
            </ModalPortal>
          )
        }
        {
          inlineErrors && touched && (
            <InlineErrors
              inlineErrors={inlineErrors}
            />
          )
        }
        {
          hasValue && modalSummaryType && (
            <ModalSummary
              modalSummaryType={modalSummaryType}
              modalData={modalData}
              readOnly={readOnly}
              editItem={this.editItem}
              deleteItem={this.openDeleteAlert}
              formData={outerFormData}
            />
          )
        }
      </div>
    );
  }
}

VFEditTable.propTypes = {
  vFParams: vFParamsPropShape,
  readOnly: PropTypes.bool,
  // we have to define the value within the data structure for field
  field: getFieldPropShape(formDataShape),
  outerFormData: formDataShape,
  form: formPropShape,
  disabledFieldOptions: disabledFieldOptionsShape,
};

const noValueVFEditTable = (value) => value.length < 1;
// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_EDIT_TABLE = 'v-f-edit-table';

export {
  VFEditTable,
  noValueVFEditTable,
  VF_EDIT_TABLE,
};
